<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-form @keyup.enter.native="handleSubmitSerch()">
				<a-input type="text" style="width: 180px; margin-right: 10px;" placeholder="审批编号" allowClear v-model="applyCode" @keyup.enter.native="handleSubmitSerch"/>
				<a-input type="text" style="width: 180px; margin-right: 10px;" placeholder="物品编号" allowClear v-model="assetSn" @keyup.enter.native="handleSubmitSerch"/>
				<a-input type="text" style="width: 180px" placeholder="物品名称" allowClear v-model="goodsName" @keyup.enter.native="handleSubmitSerch"/>
				<a-button type="primary" @click="handleSubmitSerch()" style="margin: 5px"> 搜索 </a-button>
				<a-button type="primary" @click="add" style="margin: 5px"> 新增 </a-button>
			</a-form>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :columns="columns" :data-source="data" bordered :pagination="pagination" :loading="loading" @change="handleTableChange"
			 :scroll="{ y: scroll_y }">
				<span slot="status" slot-scope="text" class="tag_class" :style="{background:colors[text]}">
					{{ statusMap6[text] }}
				</span>
				<span slot="result" slot-scope="text" class="tag_class" :style="{background:result_apply[text].color}">
					{{ resultMapConst[text] }}
				</span>
				<span slot="action" slot-scope="text, record">
					<a @click="handelAudit(record)">详情</a>
					<a-divider type="vertical" />
					<a @click="handFlow(record)">历史</a>
					<a-divider type="vertical" />
					<a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
					<!-- <a-divider type="vertical" />
					<a :disabled="record.status === 1" @click="delByIdsItem([record.id])">删除</a> -->
				</span>
			</a-table>
		</div>
		<a-modal title="固定资产-报废" :visible="visible" :closable="true" @cancel="handleCancel" :confirm-loading="confirmLoading"
		 width="1200px" :maskClosable = "false">
			<template slot="footer">
				<a-button key="back" @click="handleCancel"> 取消 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkAdd"> 提交 </a-button>
			</template>
			<a-form-model ref="ruleForm" :rules="rules" :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="报废残值价格" prop="scrappedPrice">
							<a-input v-model="info.scrappedPrice" placeholder="请输入" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"/>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="报废处理方式" prop="dealMethod">
							<a-input v-model="info.dealMethod" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="实际处理价格" prop="realPrice" >
							<a-input v-model="info.realPrice" placeholder="请输入" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"/>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="收款方式" prop="rcvMethod">
							<a-select show-search allowClear placeholder="选择收款方式" class="margin_self"
									v-model="info.rcvMethod" style="width: 100%;">
									<a-select-option value="收现" >收现</a-select-option>
									<a-select-option value="转入企业银行">转入企业银行</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="抄送人所在部门">
							<a-cascader :options="options" placeholder="请选择" @change="onChangeDept" />
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="报废原因" prop="remark"  :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
		                    <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入原因" v-model="info.remark" />
							<!-- <a-input v-model="info.remark" placeholder="请输入" /> -->
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
						<ccChange :data="ccC" :money="moneY" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-model-item>
					<!-- <a-col :span="12">
						<a-form-model-item label="选择抄送人" prop="cc">
							<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
								全选
							</a-checkbox>
							<a-checkbox-group v-model="info.cc" :options="plainOptions" @change="onChangeFroup" />
						</a-form-model-item>
					</a-col> -->
					<!-- <a-col :span="12">
						<a-form-model-item label="报废原因" prop="remark">
							<a-input v-model="info.remark" placeholder="请输入" />
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-select show-search allowClear placeholder="公司名称" class="margin_self"
						v-model="company_id" @keyup.enter.native="query" style="width: 120px">
						<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
							{{ item.title }}
						</a-select-option>
				</a-select>
				<a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" />
				<a-input v-model="keeper" allowClear class="a_input_self margin_self" placeholder="请输入保管人姓名" />
				<a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
				<a-button type="primary" style="margin: 10px" @click="query"> 查询 </a-button>
				<span><span style="color: red">* </span>请选择一项物品
					<span v-if="hasSelectedAssert" style="color: #f5222d"> 请选择报废物品</span></span>
				<a-table :columns="columns2" :data-source="data2" rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange, type:'radio' }"
				 :pagination="pagination2" bordered @change="handleTableChange2">
					<span slot="asset_type" slot-scope="text">
						{{ text ? goodsTypeObj[text] : '' }}
					</span>
					<span slot="state" slot-scope="text">
						<template>
							<a-tag :color="colors[text]">
								{{ text ? statusMapConst[text] : '' }}
							</a-tag>

						</template>
					</span>
					<!-- <span slot="dept_id" slot-scope="text">
						{{ text ? deptMap[text].text : '' }}
					</span> -->
				</a-table>
				<span style="color: red" v-if="boole">请选择一项物品</span>
			</a-form-model>
		</a-modal>
		<!-- 撤销提示 -->
		<a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
			<template slot="footer">
				<a-button key="back" @click="is_revocation = false"> 取消 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
			</template>
			<a-textarea placeholder="请输入原因" v-model="reason" />
		</a-modal>
		<!-- 报废详情 -->
		<a-modal v-model="is_details" width="80%" title="详情">
			<template slot="footer">
				<a-button key="submit" type="primary" :loading="loading" @click="is_details = false"> 确认 </a-button>
			</template>
			<a-form-model v-if="details != null" :model="details" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="申请标题">
							<span class="span">{{ details.title }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="报废原因">
							<span class="span">{{ details.remark }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span class="span">{{ details.asset.assetType ? goodsTypeObj[details.asset.assetType] : '' }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span class="span">{{ details.asset.name }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品编号">
							<span class="span">{{ details.asset.assetSn }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span class="span">{{ details.asset.model }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品状态">
							<span class="span">{{ details.asset.state ? statusMap3[details.asset.state] : '' }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span class="span">{{ details.asset.purchaseTime }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购价格">
							<span class="span">{{ details.asset.purchasePrice/100 }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="当前估值">
							<span class="span">{{ details.asset.value/100 }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="责任人">
							<span class="span">{{ details.asset.charger }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="责任部门">
							<span class="span">{{ details.asset.deptId ? deptMap[details.asset.deptId].text : '' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
		<proc-flow-modal ref="modalflow" @ok="handleOk" />
	</div>
</template>

<script>
	import debounce from 'lodash/debounce'
	import {
		resultMap,
		statusMap,
		delProcessIns,
		delBusiness,
		modalMap,
	} from '@/api/activiti'
	import {
		businesslist,
		scrappedList,
		scrapped_apply,
		assetget_list2,
		dict,
		daily_list
	} from '@/api/assetmenag'
	import {
		getDeptListEnable
	} from '@/api/system'
	import {
		get_my_lis,
		remove_my_item,
		purchase_save,
		purchase_apply_get,
			tree_all
	} from '@/api/purchase'
	import {
		returnDept2,
		get_users2,
		get_dict
	} from '@/utils/unit_axios'
	import ccChange from '@/components/module/ccChange'
	import ScrapModal from '../activiti/modules/ScrapModal.vue'
	import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue' //历史
	const deptMap = {}
	const columns = [{
			title: '审批编号',
			dataIndex: 'applyCode',
			key: 'applyCode',
			ellipsis: true,
		},
		// {
		// 	title: '申请时间',
		// 	dataIndex: 'applyTime',
		// },
		{
			title: '申请人',
			dataIndex: 'applyer',
		},
		{
			title: '物品编号',
			dataIndex: 'assetSn',
			key: 'assetSn',
			ellipsis: true,
		},
		{
			title: '物品名称',
			dataIndex: 'goodsName',
			key: 'goodsName',
			ellipsis: true,
		},
		// {
		// 	title: '标题',
		// 	dataIndex: 'title',
		// },
		{
			title: '原物品状态',
			dataIndex: 'status',
			scopedSlots: {
				customRender: 'status',
			},
		},
		{
			title: '审批结果',
			dataIndex: 'result',
			scopedSlots: {
				customRender: 'result',
			},
		},
		{
			title: '申请时间',
			dataIndex: 'applyTime',
			ellipsis: true,
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action',
			},
		},
	]
	const columns2 = [
		{
			title: '公司名称',
			dataIndex: 'company_name',
			key: 'company_name',
			ellipsis: true,
		},
		{
			title: '资产类别',
			dataIndex: 'asset_type',
			key: 'asset_type',
			scopedSlots: {
				customRender: 'asset_type',
			},
			ellipsis: true,
		},
		{
			title: '物品名称',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
		},
		{
			title: '物品编号',
			dataIndex: 'asset_sn',
			key: 'asset_sn',
			ellipsis: true,
		},
		{
			title: '规格型号',
			dataIndex: 'model',
			key: 'model',
			ellipsis: true,
		},
		{
			title: '物品状态',
			dataIndex: 'state',
			key: 'state',
			scopedSlots: {
				customRender: 'state',
			},
			ellipsis: true,
		},
		{
			title: '采购时间',
			dataIndex: 'purchase_time',
			key: 'purchase_time',
			ellipsis: true,
		},
		{
			title: '采购价格',
			dataIndex: 'purchase_price',
			key: 'purchase_price',
			ellipsis: true,
		},
		{
			title: '当前估值',
			dataIndex: 'value',
			key: 'value',
			ellipsis: true,
		},
		{
			title: '责任人',
			dataIndex: 'charger',
			key: 'charger',
			ellipsis: true,
		},
		{
			title: '责任部门',
			dataIndex: 'dept_name',
			key: 'dept_name',
			scopedSlots: {
				customRender: 'dept_name',
			},
			ellipsis: true,
		},
		{
			title: '保管人',
			dataIndex: 'keeper',
			key: 'keeper',
			ellipsis: true,
		},
	]
	export default {
		data() {
			return {
				companylist: [],
				scroll_y: 150,
				isRouterAlive: true,
				deptMap,
				statusMap,
				operTypeMap: {},
				deptTree: [],
				boole: false,
				statusMapConst: '',
				resultMapConst: resultMap,
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
				},
				pagination2: {
					current: 1,
					pageSize: 5,
					total: 0,
				},
				current: 1,
				pageSize: 10,
				total: 0,
				name: '',
				asset_sn: '',
				keeper: '',
				charger: '',
				searchValue: '', //搜索关键字
				is_revocation: false, //撤销
				ids: '', //撤销id
				reason: '', //撤销原因
				loading: false,
				form: this.$form.createForm(this, {
					name: 'coordinated',
				}),
				data: [],
				data2: [],
				selectedRowKeys: [],
				selectedRowKeys2: [],
				columns,
				columns2,
				visible: false,
				confirmLoading: false,
				applyList: {
					name: '',
					model: '',
					amount: '',
				},
				info: {
					cc: [], //抄送人
					title: '',
					assertId: '',
					remark: '',
					scrappedPrice: '',
					dealMethod: '',
					realPrice: '',
					rcvMethod: undefined,
				},
				rules: {
					remark: [{
						required: true,
						message: '请输入报废原因',
						trigger: 'blur',
					}, ],
					scrappedPrice: [{
						required: true,
						message: '请输入报废残值价格',
						trigger: 'blur',
					}, ],
					dealMethod: [{
						required: true,
						message: '请输入报废处理方式',
						trigger: 'blur',
					}, ],
					realPrice: [{
						required: true,
						message: '请输入实际处理价格',
						trigger: 'blur',
					}, ],
				},
				hasSelectedAssert: false,
				options: [], //部门
				labelCol: {
					span: 6,
				},
				wrapperCol: {
					span: 16,
				},
				labelCol2: {
					span: 2
				},
				wrapperCol2: {
					span: 22
				},
				indeterminate: false,
				checkAll: false,
				plainOptions: [], //全项
				details: null,
				is_details: false,
				ccC: 'scrapped',
				moneY:'',
				goodsName: '',
				applyCode: '',
				assetSn: '',
				timeout: null,
				company_id: undefined
			}
		},
		components: {
			ccChange,
			ScrapModal,
			ProcFlowModal
		},
		filters: {
			operTypeFilter(type) {
				return operTypeMap[type].text
			},
			deptFilter(type) {
				return deptMap[type].text
			},
		},
		created() {
			get_dict('goodStatus', (res) => {
				console.log(res)
				this.statusMapConst = res
			})
			dict({
				pageNum: 1,
				pageSize: 10,
				dictType: 'assets_type',
			}).then((res) => {
				this.assettype = res.rows
				this.assettype.map((d) => {
					this.operTypeMap[d.dictCode] = {
						text: d.dictLabel,
					}
				})
			})
			getDeptListEnable().then((res) => {
				const data = res.rows
				if (data.length > 0) {
					const min = Math.min(...data.map((m) => m.parentId))
					this.buildtree2(data, this.deptTree, min)
					this.deptTree.map((d) => {
						if (d.hasOwnProperty('children')) {
							d.children.map((b) => {
								deptMap[b.key] = {
									text: b.title,
								}
								deptMap[d.key] = {
									text: d.title,
								}
							})
						} else {
							deptMap[d.key] = {
								text: d.title,
							}
						}
					})
					this.expandedKeys = data.map((m) => m.parentId)
					this.dataList = data.map((m) => {
						return {
							key: m.deptId,
							title: m.deptName,
						}
					})
				}
			})
			this.get_lis()
			returnDept2((res) => {
				this.options = res.depts
			})
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() -120
				}, 1000)
			})
		},
		methods: {
			handFlow(row) {
				var obj = {
					procInstId: row.procInstId,
					procDefKey: row.procDefKey
				}
				this.$refs.modalflow.show(obj)
			},
			getdata(data) {
				this.info.cc = data
			},
			//改变分页
			handleTableChange2(pagination, filters, sorter) {
				this.pagination2.current = pagination.current
				this.get_lis2()
			},
			query() {
				this.pagination2.current = 1
				this.get_lis2()
			},
			onSelectChange(selectedRowKeys) {
				console.log(selectedRowKeys,this.data2)
				this.selectedRowKeys2 = selectedRowKeys
				var str=selectedRowKeys.toString()
				this.data2.forEach(item=>{
					if(item.id==str){
						this.moneY=item.purchase_price
					}
				})
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			showSizeChange(current, pageSize) {
				this.pageSize = pageSize
				this.current = current
				this.get_lis2()
			},
			onShowSizeChange(current, pageSize) {
				this.selectedRowKeys2 = []
				this.current = current
				this.get_lis2()
			},
			 get_lis2() {
				daily_list({
					pageSize: this.pagination2.pageSize,
					pageNum: this.pagination2.current,
					name: this.name,
					asset_sn: this.asset_sn,
					keeper: this.keeper,
					discard: 1,
					company_id: this.company_id,

				}).then((res) => {
					const pagination2 = { ...this.pagination2
					}
					pagination2.total = res.total
					this.pagination2 = pagination2
					this.data2 = res.rows
					// this.data2.forEach((item) => {
					// 	item.purchase_price = item.purchase_price / 100
					// 	item.value = item.value / 100
					// })
				})
			},
			//搜索
			handleSubmitSerch() {
				this.loading = true
				this.pagination.current = 1
				this.get_lis()
			},
			//获取列表
			get_lis() {
				// businesslist
				scrappedList({
					pageIndex: this.pagination.current,
					pageSize: this.pagination.pageSize,
					procDefKey: 'scrapped',
					sortField: 'id',
					sortOrder: 'desc', //  排序的方向
					goodsName: this.goodsName,
				    applyCode: this.applyCode,
				    assetSn: this.assetSn,
				}).then((res) => {
					this.data = res.rows
					this.loading = false
					const pagination = { ...this.pagination
					}
					pagination.total = res.total
					this.pagination = pagination
				})
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.loading = true
				this.get_lis()
			},
			// 撤销
			cancel(ids) {
				this.is_revocation = true
				this.ids = ids
				this.reason = ''
			},
			//撤销提交
			handleOkReason() {
				delProcessIns({
					ids: this.ids.join(','),
					reason: this.reason,
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success('撤销成功')
						this.get_lis()
						this.is_revocation = false
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			//删除
			delByIdsItem(ids) {
				var _this = this
				this.$confirm({
					title: '确认删除此申请?',
					okText: '删除',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
						remove_my_item({
							ids: ids.join(','),
						}).then((res) => {
							if (res.code === 200) {
								_this.$message.success('删除成功')
								_this.get_lis()
							} else {
								_this.$message.error(res.msg)
							}
						})
					},
					onCancel() {},
					class: 'test',
				})
			},
			//关闭申请弹框
			handleCancel(e) {
				this.$refs.ruleForm.resetFields()
				this.info = {
					cc: [], //抄送人
					title: '',
					assertId: '',
					remark: '',
					scrappedPrice: '',
					dealMethod: '',
					realPrice: '',
					rcvMethod: undefined,
				}
				this.visible = false

			},
			//选择部门
			onChangeDept(value) {
				this.info.cc = []
				this.checkAll = false
				this.info.deptKey = value[1]
				get_users2(value[1], (res) => {
					res.forEach((item) => {
						item['label'] = item.userName
						item['value'] = item.userId
					})
					this.plainOptions = res
				})
			},
			// 某项改变
			onChangeFroup(checkedList) {
				this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
				this.checkAll = checkedList.length === this.plainOptions.length
			},
			//全选改变
			onCheckAllChange(e) {
				var vs = []
				this.plainOptions.forEach((item) => {
					vs.push(item.value)
				})
				this.info.cc = e.target.checked ? vs : []
				this.indeterminate = false
				this.checkAll = e.target.checked
			},
			getCompany() {
					tree_all().then(res => {
			     if(res.code == 200) {
					 res.data[0].forEach(item => {
						 if(item.deptId == this.$store.state.user.info.companyId) {
							 this.companylist.push(item)
						 }
					 })
				 }
                })
			},
			//点击新增按钮
			add() {
				this.getCompany()
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				this.get_lis2()
				this.visible = true
				this.selectedRowKeys2 = []
				this.info.title = ''
				this.info.remark = ''
				this.hasSelectedAssert = false
			},
			//新增物品
			addGood() {
				this.info.bizGoodsInfos.push({
					assertId: '',
				})
			},
			//删除一个物品
			delGood(idx) {
				this.info.bizGoodsInfos.splice(idx, 1)
			},
			//提交
			handleOkAdd: debounce(function() {
				var _this = this
				// if(this.selectedRowKeys2=[]){
				// 	this.boole=true
				// }else{
				if (this.selectedRowKeys2.length == 0) {
					this.hasSelectedAssert = true
					return false
				}

				//增加防抖
					 clearTimeout(this.timeout)
					 console.log( this.timeout, ' this.timeout=================================')
			  this.timeout = setTimeout(() => {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						this.selectedRowKeys2.forEach((item) => {
							console.log(item)
							_this.info.assertId = item
						})
						scrapped_apply({
							cc: _this.info.cc.length ? this.info.cc.join(',') : '',
							assertId: _this.info.assertId,
							remark: _this.info.remark,
							scrappedPrice: _this.info.scrappedPrice,
							dealMethod: _this.info.dealMethod,
							realPrice: _this.info.realPrice,
							rcvMethod: _this.info.rcvMethod,
						}).then((res) => {
							console.log(res)
							if (res.code != 200) {
								this.$message.error(res.msg)
								return
							}
							this.get_lis()
							this.$message.success('新增成功！')
							this.selectedRowKeys2 = []
							this.hasSelectedAssert = false
							this.visible = false
							_this.info = {
								cc: [], //抄送人
								title: '',
								assertId: '',
								remark: '',
								scrappedPrice: '',
								dealMethod: '',
								realPrice: '',
								rcvMethod: undefined,
							}
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			}, 1000, {
				'leading': true,
				'trailing': false
			})
			}),
			handelAudit(record) {
				const modal = modalMap[record.procDefKey]
				console.log(modal)
				this.$refs[modal].show({
					businessKey: record.id,
				})
				// purchase_apply_get({
				// 	id: row.id,
				// }).then((res) => {
				// 	this.details = res.data
				// 	this.is_details = true
				// 	console.log(res)
				// })
			},
		},
	}
</script>

<style>
	.dialog {
		display: flex;
		justify-content: space-between;
	}

	.dialog .dialog_item {
		margin-bottom: 5px;
		line-height: 32px;
		display: flex;
		justify-content: space-between;
	}
</style>
